<h1 mat-dialog-title>{{title}}
  <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
  </sfc-icon>
</h1>
<div mat-dialog-content>
  <div *ngIf='hasData ; else errorTextField'>
    <ng-container #table></ng-container>

    <div class="details-panel clickable" (click)='onClick()'>
      <sfc-icon name="rds-icon-chevron-down" class='expandable' [ngClass]="{'open-button': expanded}"></sfc-icon>
      <span class="header-text" [ngClass]="{'open-text': expanded}">Koppelcodes</span>
    </div>

    <span [hidden]="!expanded">
      <ng-container #link_id_table></ng-container>
    </span>
  </div>
</div>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
